import Immutable from 'seamless-immutable'

import * as actions from './actions'

const initialState = Immutable.from({
  email: '',
  emailError: false,
  optOutError: false,
  loadingEmail: false,
  loadingOptOut: false,
  acceptNewsletter: true,
})

const newsletterOptOut = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case actions.REQUEST_EMAIL:
      return state.set('loadingEmail', true)
    case actions.RECEIVE_EMAIL:
      if (error) {
        return state.set('emailError', true).set('loadingEmail', false)
      }
      return state.set('email', payload).set('loadingEmail', false)
    case actions.REQUEST_OPT_OUT:
      return state.set('loadingOptOut', true)
    case actions.RECEIVE_OPT_OUT:
      if (error) {
        return state.set('optOutError', true).set('loadingOptOut', false)
      }
      return state.set('loadingOptOut', false).set('acceptNewsletter', false)
    default:
      return state
  }
}

export default newsletterOptOut
